import { NgModule } from '@angular/core';
import { BusinesstripApplicationManagementSharedModule } from './businesstripapplication-shared.module';
import { BusinesstripApplicationManagementRoutesModule } from './businesstripapplication.routes';
import { BusinesstripApplicationService } from './service/businesstripapplication.service';
import { TravelManagementCoreModule } from '../shared/travelmanagement-core.module';

@NgModule( {
    imports: [
        BusinesstripApplicationManagementSharedModule,
        BusinesstripApplicationManagementRoutesModule,
        TravelManagementCoreModule,
    ],
    declarations: [
    ],
    exports: [
        BusinesstripApplicationManagementSharedModule,
    ],
    providers: [
        BusinesstripApplicationService,
    ],
} )

export class BusinesstripApplicationManagementCoreModule {
}
